import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  mediaList: [],
  mediaFormList: [],
  mediaDetail: [],
  loading: false,
  error: undefined,
  success: false,
  actionType: null,
};

const mediaSlice = createSlice({
  name: "media",
  initialState,
  reducers: {
    clearError(state) {
      state.loading = false;
      state.success = false;
      state.error = undefined;
    },
    actionStart(state) {
      state.loading = true;
      state.error = undefined;
      state.actionType = null;
    },
    actionSuccess(state, action) {
      state.success = true;
      state.loading = false;
      state.actionType = action.payload || null;
    },
    fetchMediaList(state, action) {
      state.mediaList = action.payload;
      state.loading = false;
    },
    fetchMediaFormList(state, action) {
      state.mediaFormList = action.payload;
      state.loading = false;
    },
    fetchMediaDetail(state, action) {
      state.mediaDetail = action.payload;
      state.loading = false;
    },
    fetchMediaFormListClear(state, action) {
      state.mediaFormList = [];
      state.loading = false;
    },
  },
});

export const mediaActions = mediaSlice.actions;

export default mediaSlice.reducer;
